<script>
    import _ from 'lodash'

    export default {
        props: {
            callback: {
                validator: _.isFunction,
                required: true
            },
            executeOnMounted: {
                type: Boolean,
                default: false
            },
            executeOnCreated: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                result: null
            }
        },
        mounted () {
            if (this.executeOnMounted) this.execute()
        },
        created () {
            if (this.executeOnCreated) this.execute()
        },
        methods: {
            execute () {
                this.result = this.callback()

                this.$emit('success', this.result)
            }
        },
        render () {
            return this.$scopedSlots.default({
                result: this.result
            })
        }
    }
</script>
